// @workflow platform.viewer
/**
 * The 3D viewer, for clean code (src/actions/*, assistant tools, new components):
 *
 *   import { viewerFor } from '@/platform/viewer';
 *   const viewer = viewerFor(store);
 *   if (viewer.isReady()) viewer.isolateTag(tagId);
 *
 * Nothing outside src/platform/viewer/ may import forgeService.js or forgeviewer.js, or reach
 * `store.state.forgeService` / `store.state.mainApp`, unless it is in the shrinking baseline
 * (tools/check-legacy-imports.mjs). The operations are documented in core.js and its parts;
 * the workflow entry is contracts/workflows/platform.viewer.md.
 *
 * Tests build the adapter from fakes with `createViewer` (core.js), not through this file.
 */
import { createViewer } from './core.js';
import { legacyViewerDeps } from './legacy.js';

export { createViewer, PANE_TYPE_3D, PANE_TYPE_2D, VIEWER_MESSAGES } from './core.js';
export { registerViewerPanes } from './panes.js';
export { registerPageViewer, pageViewers } from './pageViewer.js';
export { SCENE_STATUS } from './scene.js';

const adapters = new WeakMap();

/**
 * The app's viewer adapter for this store (one per store; it holds no viewer state itself).
 * @param {import('vuex').Store} store
 */
export function viewerFor(store) {
  if (!adapters.has(store)) adapters.set(store, createViewer(legacyViewerDeps(store)));
  return adapters.get(store);
}
